export class KSignError extends Error {
  readonly code: number;
  readonly success: false = false;

  constructor(code: number, message: string) {
    super(message);
    this.name = 'KSignError';
    this.code = code;
  }
}

export class AgentNotAvailableError extends KSignError {
  constructor(message = 'KSign Agent is not available on this device') {
    super(0, message);
    this.name = 'AgentNotAvailableError';
  }
}

export class AgentDiscoveryError extends AgentNotAvailableError {
  constructor() {
    super(
      'KSign Agent discovery failed — ensure Agent is running, Local Root CA is trusted, and allow local network access when the browser prompts',
    );
    this.name = 'AgentDiscoveryError';
  }
}

/** Terminal WebSocket login failure (`LOGIN_FAILED` / `ERROR` / transport). */
export class LoginFailedError extends Error {
  readonly code: string;
  readonly challengeId?: string;
  readonly backendCode?: number;
  readonly success: false = false;

  constructor(
    code: string,
    message: string,
    options?: { challengeId?: string; backendCode?: number },
  ) {
    super(message);
    this.name = 'LoginFailedError';
    this.code = code;
    this.challengeId = options?.challengeId;
    this.backendCode = options?.backendCode;
  }
}

/** Wrong PIN — Agent sent PIN_RETRY and no onPinRetry handler was provided. */
export class PinRetryRequiredError extends LoginFailedError {
  constructor(reason = 'wrong_pin') {
    super('pin_retry', `PIN rejected (${reason}); provide onPinRetry to continue`);
    this.name = 'PinRetryRequiredError';
  }
}

export function mapBackendError(body: { code?: number; message?: string }): KSignError {
  return new KSignError(body.code ?? 1000, body.message ?? 'request failed');
}
